import type { VoterDetailQuery } from '../../graphql/queries/voterDetail.generated';
import { VOTER_DETAIL_ERROR_FALLBACK, fetchVoterDetail, type VoterFetchImpl } from './voterApi';
import { useVoterRequest, type VoterRequestState } from './useVoterRequest';

export type VoterDetailRecord = NonNullable<VoterDetailQuery['voterDetail']>;
export type VoterDetailData = { voter: VoterDetailRecord | null };

export type UseVoterDetailOptions = {
  id: string;
  fetchImpl?: VoterFetchImpl;
};

export const useVoterDetail = ({ id, fetchImpl }: UseVoterDetailOptions): VoterRequestState<VoterDetailData> =>
  useVoterRequest(
    id,
    async signal => ({ voter: await fetchVoterDetail({ id, signal, fetchImpl }) }),
    VOTER_DETAIL_ERROR_FALLBACK,
    fetchImpl,
  );
